document.addEventListener('DOMContentLoaded', function () {
    // --- MENU ---
    var menuBtn = document.getElementById('mbn-menu-btn');
    if (menuBtn) {
        menuBtn.addEventListener('click', function (e) {
            e.preventDefault();
            var originalMenuBtn = document.querySelector('.drawer__button');
            if (originalMenuBtn) {
                originalMenuBtn.click();
            }
        });
    }

    // --- CERCA ---
    var searchBtn = document.getElementById('mbn-search-btn');
    if (searchBtn) {
        searchBtn.addEventListener('click', function (e) {
            e.preventDefault();
            var searchDrawerBtn = document.getElementById('Search-drawer-button-header');
                if (searchDrawerBtn) searchDrawerBtn.click();
            else console.warn('Elemento con id #Search-drawer-button-header non trovato.');
        });
    }

    // --- CART ---
    var cartBtn = document.getElementById('mbn-cart-btn');
    if (cartBtn) {
        cartBtn.addEventListener('click', function (e) {
            e.preventDefault();
            var originalCartBtn = document.querySelector('.cart-drawer');
            if (originalCartBtn) {
                originalCartBtn.click();
            }
        });
    }
});